import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
@Component({
  selector: 'app-why-choose-aarni',
  templateUrl: './why-choose-aarni.component.html',
  styleUrls: ['./why-choose-aarni.component.scss']
})
export class WhyChooseAarniComponent implements OnInit {
    currentIndex = 0;
    images = [
        {
            image: 'assets/img/international-banners/why-choose-arni-1.webp',
            description: `
            <h2 class="text-6xl font-bold my-3">ARNI University</h2>
            <p class="text-xl">Welcomes the World –</p>
            <h3 class="text-4xl font-bold my-3">Let’s Learn, Grow, and Thrive Together.</h3>
        `
        },
        {
            image: 'assets/img/international-banners/why-choose-arni-2.webp',
            title: 'Scholarship Opportunity',
            description: `
            <h2 class="text-6xl font-bold my-3">Empowering Global Minds</h2>
            <p class="text-xl">with a Future-Ready Education</p>
        `
        }
    ];

    menus = [
        {label: 'Overview', id: 'overview'},
        {label: 'Quick Facts', id: 'quick-facts'},
        {label: 'Message', id: 'message'},
     /*   {label: 'Global Academic Tie-Ups', id: 'tie-ups'},*/
        {label: 'Scholarship', id: 'scholarship'},
        {label: 'How To Apply', id: 'how-to-apply'},
        /*{label: 'Testimonials', id: 'testimonials'},*/
        {label: 'Gallery', id: 'gallery'},
        {label: 'Recruiters', id: 'recruiters'}
    ];
    activeMenuId = 'overview'
    topTieUp = [
        {
            country: 'India',
            imageUrl: 'assets/img/why-choose-arni/university1.png',
            /*logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/1/1d/University_of_Calcutta_Seal.png',*/
            name: 'University of Calcutta',
            description: `One of the oldest universities in India, the University of Calcutta was founded in 1857 and has been a pioneer in the field of education and research in Eastern India. Arni University collaborates with Calcutta University on research initiatives and academic exchanges.`
        },
        {
            country: 'Nepal',
            imageUrl: 'assets/img/why-choose-arni/university1.png',
            /*logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/a/a9/Tribhuvan_University_logo.png',*/
            name: 'Tribhuvan University',
            description: `Tribhuvan University is the oldest and largest university in Nepal, established in 1959. It is known for its strong academic tradition and collaborative spirit, which aligns with Arni University's vision of regional academic cooperation.`
        },
        {
            country: 'Sri Lanka',
            imageUrl: 'assets/img/why-choose-arni/university1.png',
            /*logoUrl: 'https://upload.wikimedia.org/wikipedia/en/4/4f/University_of_Colombo_crest.png',*/
            name: 'University of Colombo',
            description: `The University of Colombo is a prestigious institution in Sri Lanka with a rich history in liberal arts, sciences, and professional education. Arni University partners with them to promote faculty exchange and joint research projects.`
        },
        {
            country: 'Bangladesh',
            imageUrl: 'assets/img/why-choose-arni/university1.png',
           /* logoUrl: 'https://upload.wikimedia.org/wikipedia/en/f/f4/University_of_Dhaka_Logo.png',*/
            name: 'University of Dhaka',
            description: `Founded in 1921, the University of Dhaka is Bangladesh’s first and most prestigious university. Arni University and Dhaka University are exploring joint programs and scholarships for South Asian students.`
        },
        {
            country: 'India',
            imageUrl: 'assets/img/why-choose-arni/university1.png',
            /*logoUrl: 'https://upload.wikimedia.org/wikipedia/en/9/91/IIT_Delhi_Logo.svg',*/
            name: 'Indian Institute of Technology Delhi',
            description: `IIT Delhi is a center of excellence in technical education and innovation in India. Through MoUs, Arni University collaborates with IIT Delhi in tech research, innovation labs, and startup mentorship.`
        },
        {
            country: 'Bhutan',
            imageUrl: 'assets/img/why-choose-arni/university1.png',
           /* logoUrl: 'https://upload.wikimedia.org/wikipedia/en/b/b1/Royal_University_of_Bhutan_Logo.png',*/
            name: 'Royal University of Bhutan',
            description: `The Royal University of Bhutan is an umbrella organization for higher education in Bhutan. Arni University works with them to develop sustainable education modules and cross-border learning programs.`
        }
    ];

    faculties = [
        {
            name: 'Dr. Rakesh Kumar',
            designation: 'Professor & Head of the Department',
            image: 'https://randomuser.me/api/portraits/men/42.jpg',
        },
        {
            name: 'Dr. Rakesh Kumar',
            designation: 'Professor & Head of the Department',
            image: 'https://randomuser.me/api/portraits/men/42.jpg',
        },
        {
            name: 'Dr. Anatoliy Kremenchutskiy',
            designation: 'Professor',
            image: 'https://randomuser.me/api/portraits/men/32.jpg',
        },
        {
            name: 'R. RAJESH KANNAN',
            designation: 'Professor & Head of the Department',
            image: 'https://randomuser.me/api/portraits/men/22.jpg',
        },
        {
            name: 'Dr. Satya Prakash',
            designation: 'Professor',
            image: 'https://randomuser.me/api/portraits/men/42.jpg',
        },
        {
            name: 'Dr. Anatoliy Kremenchutskiy',
            designation: 'Professor',
            image: 'https://randomuser.me/api/portraits/men/32.jpg',
        },
        {
            name: 'R. RAJESH KANNAN',
            designation: 'Professor & Head of the Department',
            image: 'https://randomuser.me/api/portraits/men/22.jpg',
        },
        {
            name: 'Dr. Satya Prakash',
            designation: 'Professor',
            image: 'https://randomuser.me/api/portraits/men/42.jpg',
        },
    ];
    carousolIndex = 0;
    translateX = 0;

    index = 0;
    recruiters = [
        { name: "Adani Wilmar", logo: "assets/img/companies/adani_wilmar.png" },
        { name: "Amar Ujala", logo: "assets/img/companies/amarujala.png" },
        { name: "Amazon", logo: "assets/img/companies/Amazon.png" },
        { name: "CMC", logo: "assets/img/companies/cmc-logo_0.png" },
        { name: "Dish TV", logo: "assets/img/companies/Dish_TV_2.png" },
        { name: "Future Group", logo: "assets/img/companies/FutureGroup.png" },
        { name: "HCL", logo: "assets/img/companies/hcl.png" },
        { name: "ICICI", logo: "assets/img/companies/icici_securities.png" },
        { name: "Sleepwell", logo: "assets/img/companies/sleepwell.png" },
        { name: "SYNTEL", logo: "assets/img/companies/syntel2.png" },
        {
            name: "Tech Mahindra",
            logo: "assets/img/companies/Tech_Mahindra_New_Logo1.png",
        },
        { name: "Vodafone", logo: "assets/img/companies/Vodafone_logo.png" },
        { name: "Zee TV", logo: "assets/img/companies/Zee_TV_2011.png" },
        { name: "Genpact", logo: "assets/img/companies/zenpact.png" },
        { name: "Reliance", logo: "assets/img/companies/amarujala.png" },
    ];
    scrollStep = 200;
    @ViewChild('sliderTrack') sliderTrack!: ElementRef<HTMLDivElement>
    visibleItems = 4;

    constructor() {
    }

    ngOnInit(): void {
    }

    scrollNext() {
        const track = this.sliderTrack.nativeElement;
        track.scrollLeft += this.scrollStep;

        if (track.scrollLeft >= track.scrollWidth / 2) {
            track.scrollLeft = 0;
        }
    }
    scrollPrev() {
        const track = this.sliderTrack.nativeElement;
        if (track.scrollLeft === 0) {
            track.scrollLeft = track.scrollWidth / 2;
        }
        track.scrollLeft -= this.scrollStep;
    }


    prev() {
        if (this.carousolIndex > 0) {
            this.carousolIndex--;
        } else {
            this.carousolIndex = this.topTieUp.length - this.visibleItems;
        }
        this.translateX = -this.carousolIndex * 25;
    }

    next() {
        const maxIndex = this.topTieUp.length - this.visibleItems;
        if (this.carousolIndex < maxIndex) {
            this.carousolIndex++;
        } else {
            this.carousolIndex = 0;
        }
        this.translateX = -this.carousolIndex * 25;
    }

    slide(index: number) {
        this.currentIndex = index;
    }

    scrollToSection(id: string) {
        const el = document.getElementById(id);
        if (el) {
            el.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }

}
